import { attributes, AttributesMixin, Collection, define, Model } from "@type-r/models";
import { asCurrency, Flex, Link, Loading } from "lqx-react";
import * as React from "react";
import { restfulIO } from 'api/endpoint';
import { useLinked } from "@type-r/react";
import { makeStyles } from "@material-ui/core";
import { ListField, SmallBox } from "../../../inmatch/matching/unreconciled/invoicesList";
import { globalStore } from "api";
import { OpenItems } from "./not-sent";
import { SelectedCpTab } from "src/app/pages/customerProfile/common/api";

export interface SoaNotSentGroup extends AttributesMixin<typeof SoaNotSentGroup> { }
@define
export class SoaNotSentGroup extends Model {

    static endpoint = restfulIO('/api/v2/invoices/pending-actions/soa-not-sent');

    static attributes = {
        relationshipId: Number,
        customerName: String,
        customerExternalId: String,
        failedReason: String,
        outstandingAmountSum: Number,
        sendingMethod: String,
        count: Number
    };
}

@define
export class ItemsNotSentState extends attributes({
    itemsNotSent: [SoaNotSentGroup],
    isReady: Boolean
}) {
    async fetch() {
        await this.itemsNotSent.fetch();

        this.itemsNotSent.updateEach(element => {
            let customer = globalStore.getRelationshipById(element.relationshipId).Customer;
            element.customerName = customer.companyName;
            element.customerExternalId = customer.externalRelationshipId;
        });

        return this;
    }

    getCount() {
        return this.getFiltered().length;
    }

    getFiltered() {
        return this.itemsNotSent.filter(x => x.failedReason != SoaNotSentFailedReason.Pending);
    }
}

const enum SoaNotSentFailedReason {
    EmailFailed = 'Email Failed',
    MissingEmailFrequency = 'Missing Email Frequency',
    Pending = 'Pending',
    Unknown = 'Unknown'
};

export const SoaNotSent = ({ state }: { state: ItemsNotSentState }) => {

    const reload = useLinked(true);

    return (
        state.isReady && reload.value
            ? <>
                <OpenItems
                    title={"Open Items"}
                    invoices={Collection.from(state.getFiltered())}
                    filterBy={x => x.outstandingAmountSum}
                    renderer={OpenNotSentItem()}
                    countOverride={state.itemsNotSent && state.itemsNotSent.length ? state.getFiltered().length : 0}></OpenItems>
            </>
            : <Loading />
    );
}

const OpenNotSentItem = () => ({ data, style, index }) => {
    const item = data.items[index] as SoaNotSentGroup;
    const styles = openItemStyles();

    return (
        <div style={style}>
            <SmallBox>
                <div className={styles.customerDetails} title={item.customerName}>
                    <Flex column>
                        <ListField className={styles.listField}>{item.customerName}</ListField>
                        <ListField className={styles.listField}>{item.customerExternalId}</ListField>
                    </Flex>
                </div>
                <ListField className={styles.listField}>{item.failedReason}</ListField>
                <ListField className={styles.outstandingAmount}>Sum: {asCurrency(item.outstandingAmountSum)}</ListField>
                <ListField className={styles.listField}>
                    <Link
                        href={'/customerProfile'}
                        params={
                            {
                                relationshipId: item.relationshipId,
                                selectedCpTab: SelectedCpTab.StatementOfAccount
                            }
                        }
                    >
                        View: Customer Profile
                    </Link>
                </ListField>
                <Flex grow></Flex>
            </SmallBox>
        </div>
    )
}

const openItemStyles = makeStyles({
    customerDetails: {
        minWidth: 220,
        maxWidth: 220,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "black"
    },
    outstandingAmount: {
        minWidth: 150,
        maxWidth: 150,
        color: "black"
    },
    listField: {
        color: "black"
    }
});